import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation();
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title || t('common:dialogs.confirmTitle')}</DialogTitle>
      
      <DialogContent>
        <Typography>
          {message || t('common:dialogs.confirmMessage')}
        </Typography>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>{t('common:actions.cancel')}</Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="error"
        >
          {t('common:actions.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal; 